import unknownAvatar from '../assets/images/unknownAvatar.png';
import ringtone from '../assets/audio/ringtone.mp3';

// True Eye Audio
import intro from '../assets/audio/intro.m4a';
import suspiciousActivity from '../assets/audio/suspiciousActivity.m4a';
import seriousConsequences from '../assets/audio/seriousConsequences.m4a';
import fromTheHelpDesk from '../assets/audio/fromTheHelpDesk.m4a';

// Simon Says Audio
import simonSaysCall from '../assets/audio/simon_says_call.mp3';

export function getData(id) {
  switch (id) {
    case 1: {
      return {
        audio: [simonSaysCall],
        ringer: {
          audio: ringtone,
        },
        delay: 9400,
        typeSpeed: 55,
        instructions: [
          {
            text: '844-385-2903',
            options: ['Dial'],
          },
        ],
        call: {
          avatar: unknownAvatar,
          name: 'Co-Worker Together',
          number: '844-385-2903',
        },
        intro: {
          audio: [simonSaysCall],
          caption:
            "Thanks for calling, you've reached the office of Co-Worker Together. The first workspace to incubate over 8 successful " +
            "startups in only 10 short years. We're extra proud to be celebrating our 10th anniversary on November 18th. If you'd like " +
            'to join the party or learn more about our workspace, please leave us a detailed voice message on how we can get ahold of you. ' +
            'Have a good day!',
        },
        help: {
          text: 'When you think you have the code, return to the previous window to continue.',
        },
      };
    }
    case 2: {
      return {
        audio: [ringtone, intro, suspiciousActivity, seriousConsequences, fromTheHelpDesk],
        delay: 700,
        typeSpeed: 55,
        instructions: [
          {
            text: '"Vishing" - with a "v" - stands for voice phishing.',
            options: ['1 of 3'],
          },
          {
            text:
              'Think about it like phishing, except designed to reel people in to share sensitive information over the phone.',
            options: ['2 of 3'],
          },
          {
            text:
              'You will be presented with 3 vishing scenarios. Using your best intuition, select the phone response you think would be most secure.',
            options: ["Let's Play!"],
          },
        ],
        call: {
          avatar: unknownAvatar,
          name: 'Caller Unknown',
          number: '555-938-1853',
        },
        ringer: {
          audio: ringtone,
        },
        intro: {
          audio: intro,
          caption: 'Hey this is Dan from the True Eye Corporation, may I please speak to Adrian?',
          options: {
            1: {
              text: 'Yes, this is him',
              step: {
                audio: suspiciousActivity,
                caption:
                  "Hey Adrian, I'm calling from the True Eye helpdesk. I just wanted to follow up with you about some suspicious activity we’ve been seeing on your computer.",
                options: {
                  1: {
                    text: 'What do you mean, suspicious activity?',
                    step: {
                      audio: seriousConsequences,
                      caption:
                        'I mean, there could be serious consequences if I don’t login remotely and have a look at your computer.',
                      options: {
                        1: {
                          text: "Ok, but don't delete anything I'm working on.",
                          step: {
                            instructions: [
                              {
                                text: 'Incorrect!',
                                options: ['Try next game'],
                                gameId: 3,
                              },
                            ],
                          },
                        },
                        2: {
                          text: 'I think I’m going to call the Helpdesk mainline number and see if this is legit.',
                          step: {
                            instructions: [
                              {
                                text: 'Correct!',
                                options: ['Play next game'],
                                gameId: 3,
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  2: {
                    text: 'Who did you say you were, again?',
                    step: {
                      audio: fromTheHelpDesk,
                      caption: 'Dan, from the True Eye Helpdesk',
                      options: {
                        1: {
                          text:
                            "I don’t recognize this number, Dan, I'm going to call the True Eye main number to see if this is legit.",
                          step: {
                            instructions: [
                              {
                                text: 'Correct!',
                                options: ['Play next game'],
                                gameId: 3,
                              },
                            ],
                          },
                        },
                        2: {
                          text: 'Gotcha. Just tell me what I need to do.',
                          step: {
                            instructions: [
                              {
                                text: 'Incorrect!',
                                options: ['Try next game'],
                                gameId: 3,
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      };
    }
    case 3: {
      return {
        audio: [ringtone],
        delay: 700,
        typeSpeed: 55,
        instructions: [],
        call: {
          avatar: unknownAvatar,
          name: 'True Eye Bangalore Office',
          number: '',
        },
        ringer: {
          audio: ringtone,
        },
        intro: {
          audio: 'NONE',
          caption:
            'Hi - I’m calling on behalf of the Bangalore office. We’re doing a routine check on all employee numbers to make sure they are active.',
          options: {
            1: {
              text: 'Oh, awesome thanks!',
              step: {
                audio: 'NONE',
                caption: 'No problem. While I have you here, i just have a couple questions.',
                options: {
                  1: {
                    text: 'Sure, go ahead',
                    step: {
                      audio: 'NONE',
                      caption: 'Great. First of all, can you confirm your location for me?',
                      options: {
                        1: {
                          text: 'Yup, its HQ - building 2. Cube 547',
                          step: {
                            audio: 'NONE',
                            caption:
                              'Great thanks. Can you also confirm your email address and position within the organization?',
                            options: {
                              1: {
                                text: 'adrian@trueeye.com and systems analyst',
                                step: {
                                  instructions: [
                                    {
                                      text: 'Incorrect!',
                                      options: ['Try next game'],
                                      gameId: 4,
                                    },
                                  ],
                                },
                              },
                              2: {
                                text: 'Who did you say you were?',
                                step: {
                                  audio: 'NONE',
                                  caption: 'This is Raj from the Bangalore True Eye office. Employee Ops division.',
                                  options: {
                                    1: {
                                      text: 'Never heard of that division, or you, I need more proof.',
                                      step: {
                                        audio: 'NONE',
                                        caption: 'I can only give you my word, sir',
                                        options: {
                                          1: {
                                            text: 'I can’t give you the benefit of the doubt. Bye, Raj.',
                                            step: {
                                              instructions: [
                                                {
                                                  text: 'Correct!',
                                                  options: ['Play next game'],
                                                  gameId: 4,
                                                },
                                              ],
                                            },
                                          },
                                          2: {
                                            text: 'I’ll give you the benefit of the doubt, this once.',
                                            step: {
                                              instructions: [
                                                {
                                                  text: 'Incorrect!',
                                                  options: ['Try next game'],
                                                  gameId: 4,
                                                },
                                              ],
                                            },
                                          },
                                        },
                                      },
                                    },
                                    2: {
                                      text:
                                        'Never heard of that division… or you… can you just confirm your last name before I answer your questions?',
                                      step: {
                                        audio: 'NONE',
                                        caption: 'Kapoor',
                                        options: {
                                          1: {
                                            text:
                                              'I don’t see you in the internal global address list. I’m going to hang up.',
                                            step: {
                                              instructions: [
                                                {
                                                  text: 'Correct!',
                                                  options: ['Play next game'],
                                                  gameId: 4,
                                                },
                                              ],
                                            },
                                          },
                                          2: {
                                            text: 'Alright Mr. Kapoor, how can I help?',
                                            step: {
                                              instructions: [
                                                {
                                                  text: 'Incorrect!',
                                                  options: ['Try next game'],
                                                  gameId: 4,
                                                },
                                              ],
                                            },
                                          },
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                        2: {
                          text: 'Who did you say you were?',
                          step: {
                            audio: 'NONE',
                            caption: 'This is Raj from the Bangalore True Eye office. Employee Ops division.',
                            options: {
                              1: {
                                text: 'Never heard of that division, or you, I need more proof.',
                                step: {
                                  audio: 'NONE',
                                  caption: 'I can only give you my word, sir',
                                  options: {
                                    1: {
                                      text: 'I can’t give you the benefit of the doubt. Bye, Raj.',
                                      step: {
                                        instructions: [
                                          {
                                            text: 'Correct!',
                                            options: ['Play next game'],
                                            gameId: 4,
                                          },
                                        ],
                                      },
                                    },
                                    2: {
                                      text: 'I’ll give you the benefit of the doubt, this once.',
                                      step: {
                                        instructions: [
                                          {
                                            text: 'Incorrect!',
                                            options: ['Try next game'],
                                            gameId: 4,
                                          },
                                        ],
                                      },
                                    },
                                  },
                                },
                              },
                              2: {
                                text:
                                  'Never heard of that division… or you… can you just confirm your last name before I answer your questions?',
                                step: {
                                  audio: 'NONE',
                                  caption: 'Kapoor',
                                  options: {
                                    1: {
                                      text:
                                        'I don’t see you in the internal global address list. I’m going to hang up.',
                                      step: {
                                        instructions: [
                                          {
                                            text: 'Correct!',
                                            options: ['Play next game'],
                                            gameId: 4,
                                          },
                                        ],
                                      },
                                    },
                                    2: {
                                      text: 'Alright Mr. Kapoor, how can I help?',
                                      step: {
                                        instructions: [
                                          {
                                            text: 'Incorrect!',
                                            options: ['Try next game'],
                                            gameId: 4,
                                          },
                                        ],
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      };
    }
    case 4: {
      return {
        audio: [ringtone],
        delay: 0,
        typeSpeed: 0,
        instructions: [],
        call: {
          avatar: unknownAvatar,
          name: 'Johnson City',
          number: '555-423-1853',
        },
        ringer: {
          audio: ringtone,
        },
        intro: {
          audio: 'NONE',
          caption: 'Automated message from: Guide A10375',
          options: {
            1: {
              text: 'Answer',
              step: {
                audio: 'NONE',
                caption: 'Calendar reminder for your recurring status update. How would you like to proceed?',
                options: {
                  1: {
                    text: 'Uhh... Tell me more',
                    step: {
                      audio: 'NONE',
                      caption:
                        'Meeting details are blank. There is a shortened URL link in the location line. Would you like to launch?',
                      options: {
                        1: {
                          text: 'Launch',
                          step: {
                            audio: 'NONE',
                            caption:
                              'The URL is asking for permissions to your location. Would you like to accept? This is a very common request.',
                            options: {
                              1: {
                                text: 'Yes - accept',
                                step: {
                                  audio: 'NONE',
                                  caption: 'Guide A10375 is now tracking your location',
                                  options: {
                                    1: {
                                      text: 'Ok',
                                      step: {
                                        instructions: getOutro('INCORRECT!'),
                                      },
                                    },
                                  },
                                },
                              },
                              2: {
                                text: 'No - decline',
                                step: {
                                  audio: 'NONE',
                                  caption: 'Guide A10375 has been denied access to your location',
                                  options: {
                                    1: {
                                      text: 'Who does that Guide belong to?',
                                      step: {
                                        audio: 'NONE',
                                        caption: 'T. Sherman',
                                        options: {
                                          1: {
                                            text: 'Ok. Go ahead and give him access.',
                                            step: {
                                              instructions: getOutro('INCORRECT!'),
                                            },
                                          },
                                          2: {
                                            text: 'Ok, Guide disconnect.',
                                            step: {
                                              instructions: getOutro('CORRECT!'),
                                            },
                                          },
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      };
    }
    default:
  }
}

function getOutro(result) {
  return [
    {
      text: result,
      options: ['Finish'],
    },
    {
      text:
        'Why do you think a vishing scam works? Because people can be caught off guard by urgency, threats and pressure to act. People can also be poorly trained to combat urgency, threats and pressures at work.',
      options: ['1 of 4'],
    },
    {
      text:
        "Most people don't realize that the call-back method can reduce risk and ensure you stay safe! This helps you stop, think, breathe and ask someone before you react on impulse! If it is a legitimate caller, dialing their primary phone number online should re-connect you.",
      options: ['2 of 4'],
    },
    {
      text:
        'Just remember: phone scammers elicit sensitive information by appealing to your trust. Let’s just say a healthy sense of paranoia on the phone could save your ass-ets.',
      options: ['3 of 4'],
    },
    {
      title: 'Return to the course and enter the passcode:',
      text: '#EscapedTheVish',
      copy: true,
    },
  ];
}
